import {
	getModelConfig,
	getModelConfigBySlug,
	updateModel,
	getMasterClassList,
	uploadModelFile,
	getInfo,
	uploadNewModel,
	getQualityGates,
	deleteRevision,
	activateRevision,
	importModelAPI,
} from 'src/actions/modelActions';
import { getViewsRedux } from './viewActionsRedux';

import store from 'src/redux/store/reduxStoreIndex';

export const REQUEST_ACTIVE_MODEL = 'request_active_model';
export const RECEIVE_ACTIVE_MODEL = 'receive_active_model';
export const ACTIVE_MODEL_ERROR = 'active_model_error';

export const REQUEST_MODEL_INFO = 'request_model_info';
export const RECEIVE_MODEL_INFO = 'receive_model_info';
export const MODEL_INFO_ERROR = 'model_info_error';

export const REQUEST_UPDATE_MODEL = 'request_update_model';
export const RECEIVE_UPDATE_MODEL = 'receive_update_model';
export const UPDATE_MODEL_ERROR = 'update_model_error';

export const REQUEST_DELETE_REVISION = 'request_delete_revision';
export const RECEIVE_DELETE_REVISION = 'receive_delete_revision';
export const DELETE_REVISION_ERROR = 'delete_revision_error';

export const REQUEST_ADD_MODEL = 'request_add_model';
export const RECEIVE_ADD_MODEL = 'receive_add_model';
export const ADD_MODEL_ERROR = 'add_model_error';

export const REQUEST_MASTERCLASS_LIST = 'request_masterclass_list';
export const RECEIVE_MASTERCLASS_LIST = 'receive_masterclass_list';
export const MASTERCLASS_LIST_ERROR = 'masterclass_list_error';

export const REQUEST_QUALITY_GATES = 'request_quality_gates';
export const RECEIVE_QUALITY_GATES = 'receive_quality_gates';
export const QUALITY_GATES_ERROR = 'quality_gates_error';

export const CLEAR_ACTIVE_MODEL = 'clear_active_model';
export const RECEIVE_MODEL_DATA_UPDATE = 'receive_model_data_update';

const getActiveModelRedux =
	(modelItentifier, slug = false) =>
	async (dispatch) => {
		const onRequest = () => {
			// dipatch request string to be handled by reducers
			dispatch({
				type: REQUEST_ACTIVE_MODEL,
			});
		};
		const onSuccess = (success) => {
			dispatch({
				// dipatch receive string and payload to be handled by reducer
				type: RECEIVE_ACTIVE_MODEL,
				payload: success,
			});
			return success;
		};
		const onError = (error) => {
			dispatch({
				// dipatch error string and payload to be handled by reducer
				type: ACTIVE_MODEL_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			// make api call
			let models;
			if (slug) {
				models = await getModelConfigBySlug(modelItentifier);
			} else {
				models = await getModelConfig(modelItentifier);
			}
			return onSuccess(models);
		} catch (error) {
			console.error(error);
			return onError(error);
		}
	};

const getModelInfoRedux = (modelId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_MODEL_INFO,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_MODEL_INFO,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: MODEL_INFO_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await getInfo(modelId);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const updateModelRedux = (model) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_UPDATE_MODEL,
			modelId: model?._id,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_UPDATE_MODEL,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: UPDATE_MODEL_ERROR,
			payload: error,
			modelId: model?._id,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await updateModel(model);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const addModelDataRedux =
	(modelId, modelFile, customRevName = '', activateNewModel = true) =>
	async (dispatch) => {
		const onRequest = () => {
			// dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_ADD_MODEL,
			});
		};
		const onAddModelSuccess = (success) => {
			dispatch({
				// dipatch receive string and payload to be handled by reducer
				type: RECEIVE_ADD_MODEL,
				payload: success,
			});
			return success;
		};
		const onUpdateModelDataSuccess = (success) => {
			dispatch({
				// dipatch receive string and payload to be handled by reducer
				type: RECEIVE_MODEL_DATA_UPDATE,
				payload: success,
			});
			return success;
		};
		const onError = (error) => {
			dispatch({
				// dipatch error string and payload to be handled by reducer
				type: ADD_MODEL_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			// make api call
			const data = await uploadModelFile(modelId, modelFile, customRevName, activateNewModel);

			store.dispatch(getModelInfoRedux(data._id));
			return onUpdateModelDataSuccess(data);
		} catch (error) {
			console.error(error);
			return onError(error);
		}
	};

const addModelRedux = (modelData, modelFile) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ADD_MODEL,
		});
	};
	const onAddModelSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_ADD_MODEL,
			payload: success,
		});
		return success;
	};
	const onUpdateModelDataSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_MODEL_DATA_UPDATE,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ADD_MODEL_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await uploadNewModel(modelData, modelFile);
		store.dispatch(getModelInfoRedux(data._id));
		store.dispatch(getViewsRedux(data._id));
		return onAddModelSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const importModelRedux = (modelFile) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ADD_MODEL,
		});
	};
	const onAddModelSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_ADD_MODEL,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ADD_MODEL_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await importModelAPI(modelFile);
		onAddModelSuccess(data);
		await store.dispatch(getModelInfoRedux(data._id));
		await store.dispatch(getViewsRedux(data._id));
		return data;
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const clearActiveModelRedux = () => async (dispatch) => (success) => {
	dispatch({
		type: CLEAR_ACTIVE_MODEL,
		payload: success,
	});
	return success;
};

const getMasterClassListRedux = (modelId, revision) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_MASTERCLASS_LIST,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_MASTERCLASS_LIST,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: MASTERCLASS_LIST_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await getMasterClassList(modelId, revision);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const getQualityGatesRedux = (modelId, qualityGateId, revision) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_QUALITY_GATES,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_QUALITY_GATES,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: QUALITY_GATES_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await getQualityGates(modelId, qualityGateId, revision);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

const deleteModelRevisionRedux = (modelId, revision) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_DELETE_REVISION,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_MODEL_INFO,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: DELETE_REVISION_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await deleteRevision(modelId, revision);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};
const activateModelRevisionRedux = (modelId, revision) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_MODEL_INFO,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_MODEL_INFO,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: MODEL_INFO_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const data = await activateRevision(modelId, revision);
		return onSuccess(data);
	} catch (error) {
		console.error(error);
		return onError(error);
	}
};

export {
	addModelDataRedux,
	addModelRedux,
	getActiveModelRedux,
	clearActiveModelRedux,
	updateModelRedux,
	getMasterClassListRedux,
	getModelInfoRedux,
	getQualityGatesRedux,
	deleteModelRevisionRedux,
	activateModelRevisionRedux,
	importModelRedux,
};
